<template>
  <div>
    <credenciamento-fornecedor-esclarecimento-impugnacao-nao-habilitado v-if="!licitacao.esclarecimentoImpugnacao"/>
    <div v-else>
      <div class="">
        <v-menu offset-y v-if="licitacao.publicado && !ehCredenciamentoAguardandoAbertura">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on">
              Solicitar
            </v-btn>
          </template>
          <v-list>
            <v-list-tile
                v-for="(tipo) in tiposAnexoFornecedor"
                :key="tipo.chave"
                @click="abrirModalSolicitacao(tipo.chave)"
            >
              <v-list-tile-title>{{ tipo.label }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
      <credenciamento-esclarecimento-impugnacao :esclarecimentos="esclarecimentosDados"
                                                :impugnacoes="impugnacaoDados"></credenciamento-esclarecimento-impugnacao>
      <credenciamento-fornecedor-esclarecimento-solicitacao :item="tipoSelecionado"
                                             :solicitacao="solicitacao"
                                             v-if="exibirModalSolicitacao"
                                             @fecharDetalhe="fecharDetalhe()"
                                             @solicitacaoSalva="buscaTodos()"
                                             @solicitacaoEnviada="buscaTodos()"
                                             @solicitacaoEditada="buscaTodos()"
      ></credenciamento-fornecedor-esclarecimento-solicitacao>
      <az-dialog v-if="exibirModalDataAbertura"
                 :width=600 @ok="exibirModalDataAbertura = false">
        <div>
        <span>Caro senhor fornecedor, o prazo para solicitações de esclarecimento/impugnação foi encerrado.</span>
        </div>
      </az-dialog>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import moment from "moment"
import {actionTypes, tiposAnexoFornecedor} from '@/commons/constants'
import EsclarecimentoImpugnacao from '../commons/EsclarecimentoImpugnacao.vue'
import CredenciamentoFornecedorEsclarecimentoSolicitacao
  from './modal/CredenciamentoFornecedorEsclarecimentoSolicitacao.vue'
import CredenciamentoFornecedorEsclarecimentoImpugnacaoNaoHabilitado
  from '@/views/credenciamento/detalhe-credenciamento/fornecedor/CredenciamentoFornecedorEsclarecimentoImpugnacaoNaoHabilitado.vue';
import CredenciamentoEsclarecimentoImpugnacao
  from '@/views/credenciamento/detalhe-credenciamento/orgao/EsclarecimentoImpugnacao/CredenciamentoEsclarecimentoImpugnacao.vue';

export default {
    name: "credenciamentoFornecedorEsclarecimentoImpugnacao",
    components: {
      CredenciamentoEsclarecimentoImpugnacao,
      CredenciamentoFornecedorEsclarecimentoImpugnacaoNaoHabilitado,
      EsclarecimentoImpugnacao, CredenciamentoFornecedorEsclarecimentoSolicitacao},
    data(){
      return {
        tipoSelecionado: undefined,
        exibirModalSolicitacao: false,
        exibirModalDataAbertura: false,
        solicitacao: {
          licitacao: {id: undefined},
          assunto: '',
          usuario: {id: undefined},
          tipo: '',
          arquivoUri: '',
          arquivoNome: ''
        },
        esclarecimentosDados: [],
        impugnacaoDados: [],
        pollingTimer: null
      }
    },
    computed: {
        tiposAnexoFornecedor(){
          return tiposAnexoFornecedor
        },
        ...mapState(['licitacao']),
        ehCredenciamentoAguardandoAbertura() {
          if (this.licitacao && this.licitacao.publicado) {
            const dataAbertura = moment(this.licitacao.dataAbertura)
            const dataAtual = moment(new Date())
            return dataAtual.isBefore(dataAbertura)
          }
          return false
        }
    },
    watch: {
      ehCredenciamentoAguardandoAbertura(novo) {
        if (novo) {
          this.iniciarPollingAbertura()
        } else {
          this.pararPollingAbertura()
        }
      }
    },
    async mounted() {
        await this.buscarEsclarecimentosLicitacao()
        await this.buscarImpugnacoesLicitacao()
        if (this.ehCredenciamentoAguardandoAbertura) {
          this.iniciarPollingAbertura()
        }
    },
    beforeDestroy() {
      this.pararPollingAbertura()
    },
    methods: {
        validaDataDeAbertura(){
          return moment().tz('America/Sao_Paulo').format() > moment(this.licitacao.dataLimiteEsclarecimentoImpugnacao).tz('America/Sao_Paulo').format();
        },
        abrirModalSolicitacao(tipo){
          this.tipoSelecionado = tipo

          if(this.validaDataDeAbertura())
              this.exibirModalDataAbertura = true
          else
            this.exibirModalSolicitacao = true
        },
        async buscarEsclarecimentosLicitacao() {
            this.setMensagemLoading('Atualizando listagem de esclarecimentos...')
            const resposta = await this.buscarEsclarecimentos(this.$route.params.id)
            if (resposta) {
              this.esclarecimentosDados = resposta.esclarecimentos
            }
        },
        async buscarImpugnacoesLicitacao() {
            this.setMensagemLoading('Atualizando listagem de impugnações...')
            const resposta = await this.buscarImpugnacoes(this.$route.params.id)
            if (resposta) {
              this.impugnacaoDados = resposta.impugnacoes
            }
        },
        fecharDetalhe(){
            this.exibirModalSolicitacao = false
            this.buscarImpugnacoesLicitacao()
            this.buscarEsclarecimentosLicitacao()
        },
        buscaTodos(){
          this.buscarImpugnacoesLicitacao()
          this.buscarEsclarecimentosLicitacao()
          this.exibirModalSolicitacao = false;
        },
        iniciarPollingAbertura() {
          if (this.pollingTimer) return
          this.pollingTimer = setInterval(async () => {
            if (!this.ehCredenciamentoAguardandoAbertura) {
              await this.buscarLicitacao(this.$route.params.id)
              clearInterval(this.pollingTimer)
              this.pollingTimer = null
            }
          }, 5000)
        },
        pararPollingAbertura() {
          if (this.pollingTimer) {
            clearInterval(this.pollingTimer)
            this.pollingTimer = null
          }
        },
        ...mapActions([
            actionTypes.BUSCAR_ESCLARECIMENTOS,
            actionTypes.BUSCAR_IMPUGNACOES,
            actionTypes.BUSCAR_LICITACAO
        ])
    },
    filters: {
      tipoAnexoFornecedor(tipoAnexoChave) {
        const tipoSelecionado = tiposAnexoFornecedor.find(tipoObj => tipoObj.chave === tipoAnexoChave)
        return tipoSelecionado ? tipoSelecionado.label : ''
      }
    }
}
</script>

<style scoped>

</style>